export default __webpack_public_path__ + "static/highlights-fafa8390581373cffc6d468abc97088d.png";